import images from '@/assets/images'
import './index.less'

const SJSite = () => {
  return (
    <div className="sc-site">
      <img className="sc-site-img" src={images.site} alt="" />
    </div>
  )
}

export default SJSite
